import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import reviewType from "./types/reviewType";
import {
  FullReviewWrapper,
  CloseButton,
  Author,
  ReviewDate,
  ReviewText,
  FullReviewStarRating,
  FillRating,
  Stars,
  EmptyRating,
} from "./styles/reviews-styles";

const ViewFullReview = ({ review, revieweeName, average, handleClose }) => (
  <FullReviewWrapper>
    <CloseButton onClick={() => handleClose(null)} className="animated fadeIn">
      <FontAwesomeIcon icon={faTimes} />
    </CloseButton>
    <Author className="animated fadeIn">{revieweeName}&apos;s review </Author>
    <ReviewDate className="animated fadeIn delay-1">
      {review.createdAt}
    </ReviewDate>
    <FullReviewStarRating className="animated fadeIn delay-1">
      <FillRating style={{ width: `${average}%` }}>
        <Stars>★★★★★</Stars>
      </FillRating>
      <EmptyRating>
        <Stars>★★★★★</Stars>
      </EmptyRating>
    </FullReviewStarRating>
    <ReviewText className="animated fadeIn delay-2">
      &quot;{review.message}&quot;
    </ReviewText>
  </FullReviewWrapper>
);

ViewFullReview.propTypes = {
  average: PropTypes.number.isRequired,
  review: reviewType,
  handleClose: PropTypes.func.isRequired,
  revieweeName: PropTypes.string.isRequired,
};

ViewFullReview.defaultProps = {
  review: PropTypes.isNull,
};

export default ViewFullReview;
